import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Input from './Input';
import { lengthValidator } from '../config';
export default (function (props) {
  var required = props.required;
  var validator = function validator(value) {
    var reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return required ? 'The Field is required' : undefined;
    }
    if (!reg.test(value)) {
      return 'Invalid email address';
    }
    return lengthValidator(value, props);
  };
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    validator: validator
  }));
});